import React from "react";

const GoodIcon = ({
  className = "true-icon",
  fill = "#73C9C1",
  height="20",
  width = "20",
  viewBox = "0 0 16 16"
}) => (
    <svg className={className} width={width} height={height} viewBox={viewBox} transform="translate(0, 2.5)">
        <path id="Good-Icon" fill={fill} d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm3.293-11.332L6.75 9.21 4.707 7.168 3.293 8.582 6.75 12.04l5.957-5.957-1.414-1.414z">
        </path>
    </svg>
);

const BadIcon = ({
  className = "false-icon",
  fill = "#b20000",
  height="20",
  width = "20",
  viewBox = "0 0 16 16"
}) => (
    <svg className={className} width={width} height={height} viewBox={viewBox} transform="translate(0, 2.5)">
      <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
       <g id="UI-Icons" transform="translate(-818.000000, -298.000000)" fill={fill}>
           <g id="UI-Icon/close--solid/$ui-05" transform="translate(818.000000, 298.000000)">
               <path d="M8,6.58578644 L5.87867966,4.46446609 L4.46446609,5.87867966 L6.58578644,8 L4.46446609,10.1213203 L5.87867966,11.5355339 L8,9.41421356 L10.1213203,11.5355339 L11.5355339,10.1213203 L9.41421356,8 L11.5355339,5.87867966 L10.1213203,4.46446609 L8,6.58578644 Z M8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 Z" id="x"></path>
           </g>
       </g>
   </g>
</svg>
);

const CircledMaintenanceIcon = ({
  className = "circled-maintenance-icon",
  fill = "#f6ce54",
  height="20",
  width = "20",
  viewBox = "0 0 16 16"
}) => (
<svg className={className} width={width} height={height} viewBox={viewBox} transform="translate(0, 2.5)">
  <g id="Maintenance-Status-" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="Maintenance-Icon----Dark-Yellow">
      <g id="Group-6">
        <circle id="BackGround-Circle" cx="8" cy="8" r="8" fill={fill}/>
        <g id="Maintenance-Icon-White" transform="translate(10.853553, 9.646447) rotate(45.000000) translate(-10.853553, -9.646447) translate(3.353553, 1.146447)" fill="#fff">
          <path d="M6,10.5719534 L6,15.2422255 C6,16.0706526 5.32842712,16.7422255 4.5,16.7422255 C3.67157288,16.7422255 3,16.0706526 3,15.2422255 L3,10.5719534 C1.25221144,9.95419875 1.36424205e-12,8.28734016 1.36424205e-12,6.32801192 C1.36424205e-12,4.76780387 0.794014257,3.39304778 2,2.58578644 L2,5.82801192 C2,6.65643904 2.67157288,7.32801192 3.5,7.32801192 L5.5,7.32801192 C6.32842712,7.32801192 7,6.65643904 7,5.82801192 L7,2.58578644 C8.20598574,3.39304778 9,4.76780387 9,6.32801192 C9,8.28734016 7.74778856,9.95419875 6,10.5719534 Z" id="Combined-Shape" stroke={fill}></path>
        </g>
      </g>
    </g>
  </g>
</svg>
);

const PartiallyAvailableIcon = ({
  className = "circled-partially-available-icon",
  fill = "orange",
  height="20",
  width = "20",
  viewBox = "-1367 297 200 200"
}) => (
<svg className={className} width={width} height={height} viewBox={viewBox} transform="translate(0, 2.5)">
  <g id="Partially-Available-Status-" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="Partially-Available-Icon----Dark-Yellow">
      <g id="Group-6">
        <g id="Group-5" fill={fill}>
          <path d="M-1267 426.8c-5.4 0-10 4.4-10 10 0 5.4 4.4 10 10 10s10-4.4 10-10c0-5.4-4.6-10-10-10zm-10-59.6l5 49.8h10l5-49.8v-20h-20v20zm10-70.2c-55.2 0-100 44.8-100 100s44.8 100 100 100 100-44.8 100-100-44.8-100-100-100zm0 185.8c-47.2 0-85.8-38.6-85.8-85.8s38.6-85.8 85.8-85.8 85.8 38.4 85.8 85.8c0 47.2-38.6 85.8-85.8 85.8z" id="Partially-Available-Icon-Shape"></path>
        </g>
      </g>
    </g>
  </g>
</svg>
);


const UnknownIcon = ({
  className = "unknown-status-icon",
  fill = "#93A2AA",
  height="20",
  width = "20",
  viewBox = "0 0 16 16"
}) => (
<svg className={className} width={width} height={height} viewBox={viewBox} transform="translate(0, 2.5)">
    <g id="Page-1" stroke="none" strokeWidth="1" fill={fill} fillRule="evenodd">
        <g id="icon">
        <circle id="Unknown-Circle" cx="8" cy="8" r="8" fill={fill}/>
          <g id="Group-6" transform="translate(-2, -1)">
            <path d="M9.6378744,11.8374512 C9.62936209,11.3692742 9.66128277,10.9436651 9.7336374,10.5606112 C9.80599203,10.1775573 10.0081563,9.81153348 10.3401364,9.4625288 C10.5274072,9.26674569 10.7231874,9.0752216 10.9274828,8.8879508 C11.1317782,8.70068 11.3190462,8.51128396 11.4892924,8.319757 C11.6595386,8.12823004 11.8021176,7.93032182 11.9170338,7.7260264 C12.03195,7.52173098 12.0894072,7.30041426 12.0894072,7.0620696 C12.0894072,6.83223725 12.0447182,6.61730467 11.955339,6.4172654 C11.8659598,6.21722613 11.736149,6.04272641 11.5659028,5.893761 C11.3956566,5.74479559 11.1871082,5.62775309 10.9402512,5.54263 C10.6933942,5.45750691 10.4124922,5.414946 10.0975368,5.414946 C9.78258136,5.414946 9.50167937,5.47027518 9.2548224,5.5809352 C9.00796543,5.69159522 8.80154503,5.84481449 8.635555,6.0405976 C8.46956497,6.23638071 8.34401029,6.46408157 8.2588872,6.723707 C8.17376411,6.98333243 8.13545929,7.26636247 8.1439716,7.5728056 L7.3650992,7.5728056 C7.33104996,7.14719014 7.37786696,6.75988588 7.5055516,6.4108812 C7.63323624,6.06187652 7.82263228,5.76182212 8.0737454,5.510709 C8.32485852,5.25959588 8.62491292,5.06594375 8.9739176,4.9297468 C9.32292228,4.79354985 9.70597045,4.7254524 10.1230736,4.7254524 C10.5572014,4.7254524 10.9466337,4.78290963 11.2913822,4.8978258 C11.6361307,5.01274197 11.9276729,5.17447342 12.1660176,5.383025 C12.4043623,5.59157658 12.5873742,5.84481398 12.7150588,6.1427448 C12.8427434,6.44067562 12.9065848,6.76839461 12.9065848,7.1259116 C12.9065848,7.50045321 12.823591,7.82178806 12.657601,8.0899258 C12.491611,8.35806354 12.2894467,8.60704485 12.051102,8.8368772 C11.8127573,9.06670955 11.5659041,9.2986665 11.3105348,9.532755 C11.0551655,9.7668435 10.8338488,10.0285931 10.646578,10.3180116 C10.5018687,10.5393316 10.421003,10.7840569 10.4039784,11.0521946 C10.3869538,11.3203323 10.3784416,11.5820819 10.3784416,11.8374512 L9.6378744,11.8374512 Z M9.561264,14.1613 L9.561264,13.0376808 L10.4933572,13.0376808 L10.4933572,14.1613 L9.561264,14.1613 Z" id="Unknown-Icon-Shape" fill="#fff"></path>
          </g>
        </g>
    </g>
</svg>
);

const BallIcon = ({
  className = "ball-icon",
  fill = "#3d70b2",
  height="20",
  width = "20",
  viewBox = "0 0 16 16"
}) => (
    <svg className={className} width={width} height={height} viewBox={viewBox} transform="translate(0, 2.5)">
      <circle cx="8" cy="8" r="8" fill={fill}/>
    </svg>
);

export {GoodIcon, BadIcon, CircledMaintenanceIcon, PartiallyAvailableIcon, UnknownIcon, BallIcon};
